import { isArray, isObject, isString } from 'lodash'
import fieldId from '../constants/layout/fieldId'
import getElemPosition from '../utils/getElemPosition'
import { animateScroll } from 'react-scroll'

export default function(errors, root) {
  const ids = []
  const traverse = (obj, path) => {
    path = path || ''

    for (const item in obj) {
      if (obj.hasOwnProperty(item)) {
        if (isObject(obj[item]) || isArray(obj[item])) {
          traverse(obj[item], path + '.' + item)
        } else if (obj[item]) {
          item && ids.push(path + '.' + item)
        }
      }
    }
  }

  traverse(errors, isString(root) ? root : fieldId)
  const selector = ids.map(item => `[id="${item}"]`).join(', ')
  const elems = selector && document.querySelectorAll(selector)
  const elem = elems && elems[0]

  elem && animateScroll.scrollTo(getElemPosition(elem).y - 25, { containerId: 'scrollContrainer' })
}
